import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { X, CheckCircle, AlertTriangle } from 'lucide-react';

function AlertMsg({ message, type, onClose }) {
  useEffect(() => {
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  // Define styling based on type
  const alertStyles = {
    success: {
      border: 'border-green-500',
      text: 'text-green-600',
      icon: <CheckCircle className="mr-2" size={20} />
    },
    error: {
      border: 'border-red-500',
      text: 'text-red-600',
      icon: <AlertTriangle className="mr-2" size={20} />
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-5 bg-black bg-opacity-50">
      <div className="w-full flex justify-center">
        <motion.div
          className={`bg-white rounded-lg shadow-sm w-4/5 max-w-md flex flex-col ${alertStyles[type].border} border`}
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
        >
          <div className="flex justify-between items-center p-4 bg-gray-50 border-b border-gray-200 rounded-t-lg">
            <div className="flex items-center">
              {alertStyles[type].icon}
              <h2 className={`m-0 text-lg font-medium ${alertStyles[type].text}`}>
                {type.charAt(0).toUpperCase() + type.slice(1)}
              </h2>
            </div>
            <button
              className="text-gray-500 hover:text-gray-700 transition-colors focus:outline-none"
              onClick={onClose}
              aria-label="Close"
            >
              <X size={18} />
            </button>
          </div>

          <div className="p-4 text-sm text-gray-700">
            <span>{message}</span>
          </div>

          <div className="flex justify-end p-4 border-t border-gray-100">
            <button
              className="px-4 py-2 bg-blue-500 text-white rounded-md cursor-pointer hover:bg-blue-600 transition-colors"
              onClick={onClose}
            >
              OK
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  );
}

export default AlertMsg;